import { MaybeSavedQueryMeta } from '@/views/SavedQueries/types';

export const hasDashboards = (meta: MaybeSavedQueryMeta) =>
  (meta?.dashboardIds?.()?.length ?? 0) > 0;

export const hasInsightError = (meta: MaybeSavedQueryMeta) =>
  Boolean(meta?.errorMsg?.());

export const hasAlerts = (meta: MaybeSavedQueryMeta) =>
  (meta?.emailDestinations?.()?.length ?? 0) > 0;

export const hasSlackAlerts = (meta: MaybeSavedQueryMeta) =>
  (meta?.slackDestinations?.()?.length ?? 0) > 0;

export const hasS3Feeds = (meta: MaybeSavedQueryMeta) =>
  (meta?.bucketFeeds?.()?.length ?? 0) > 0;

export const hasZaps = (meta: MaybeSavedQueryMeta) =>
  (meta?.zapierCount?.() ?? 0) > 0;

export const isGoogleSheetsSharable = (meta: MaybeSavedQueryMeta) =>
  Boolean(meta?.isSheetsShareable?.());

export const isOtherShareable = (meta: MaybeSavedQueryMeta) =>
  Boolean(meta?.isOtherShareable?.());
